export default __webpack_public_path__ + "static/media/SteeringWheel.d1c2a659.svg";